import { Api } from "./base";

const _headers = () => ({
  Authorization: "JWT " + require("store").default.getState().onboard.user.auth_token,
  "Content-Type": "application/json",
});

export default {
  list(search = "", voice = "", offset = 0) {
    return Api.getBaselineData(
      `/lexicon/v1/pronunciation/?search=${search}&voice=${voice}&offset=${offset}`,
      { headers: _headers() }
    );
  },

  create(data) {
    return Api.postBaselineData("/lexicon/v1/pronunciation/", data, _headers());
  },

  update(id, data) {
    return Api.putBaselineData(`/lexicon/v1/pronunciation/${id}/`, data, _headers());
  },

  remove(id) {
    return Api.deleteBaselineData(`/lexicon/v1/pronunciation/${id}/`, {
      headers: _headers(),
    });
  },

  previewTTS(text, voice, rate) {
    return Api.postBaselineData(
      "/misc/v1/get-tts-audio/",
      { text, voice, rate },
      _headers()
    ).then((res) => res.result);
  },

  listVoices() {
    return Api.getBaselineData("/lexicon/v1/pronunciation/voices/", {
      headers: _headers(),
    });
  },
};
